var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { property } from 'lit/decorators.js';
import englishTranslation from './languages/en.json';
import norwegianTranslation from './languages/no.json';
import i18n, { changeLanguage, t, init } from 'i18next';
import { reduxBind } from 'badphraim/redux/Common';
import { BoostPortalStore } from '../redux/BoostPortalStore';
import { litReduxBoostPortalMixin } from '../redux/LitReduxBoostPortalMixin';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
export var BoostLanguage;
(function (BoostLanguage) {
    BoostLanguage["ENGLISH"] = "en";
    BoostLanguage["NORWEGIAN"] = "no";
})(BoostLanguage || (BoostLanguage = {}));
export const DEFAULT_LANGUAGE = BoostLanguage.NORWEGIAN;
export const SUPPORTED_LANGUAGES = [BoostLanguage.ENGLISH, BoostLanguage.NORWEGIAN];
export function BoostPortalTranslateMixin(Base) {
    class Mixin extends litReduxBoostPortalMixin(Base) {
        constructor() {
            super(...arguments);
            this.onLanguageChange = () => {
                const currentLanguage = i18n.language;
                if (!this._isAllowedLanguage(currentLanguage)) {
                    return;
                }
                let newLanguage;
                switch (currentLanguage) {
                    case BoostLanguage.ENGLISH:
                        newLanguage = BoostLanguage.NORWEGIAN;
                        break;
                    case BoostLanguage.NORWEGIAN:
                        newLanguage = BoostLanguage.ENGLISH;
                        break;
                    default:
                        newLanguage = BoostLanguage.NORWEGIAN;
                }
                this.dispatch(BoostPortalStore.Actions.SetSelectedLanguage(newLanguage));
                changeLanguage(newLanguage);
                this.setLanguageCookie(newLanguage);
            };
        }
        _isAllowedLanguage(language) {
            return SUPPORTED_LANGUAGES.includes(language);
        }
        translationContainsHTML(input) {
            if (!input) {
                return false;
            }
            if (!input.includes('<')) {
                return false;
            }
            const parser = new DOMParser();
            const document = parser.parseFromString(input, 'text/html');
            return document.body.children.length > 0;
        }
        boostTranslate(key, options) {
            let translation;
            if (options) {
                translation = t(key, options);
            }
            else {
                translation = t(key);
            }
            if (this.translationContainsHTML(translation)) {
                throw new Error(`Line break in translation, incorrect method. Key: ${key}`);
            }
            return translation;
        }
        boostTranslateOutputHtml(key, options) {
            if (options) {
                return unsafeHTML(t(key, Object.assign(Object.assign({}, options), { escapeValue: true })));
            }
            return unsafeHTML(t(key, { escapeValue: false }));
        }
        initializeTranslation() {
            init({
                lng: this.getLanguageFromCookie() || 'no',
                fallbackLng: BoostLanguage.ENGLISH,
                supportedLngs: [BoostLanguage.ENGLISH, BoostLanguage.NORWEGIAN],
                resources: {
                    en: { translation: englishTranslation },
                    no: { translation: norwegianTranslation },
                },
                interpolation: {
                    escapeValue: true,
                },
            });
            this.dispatch(BoostPortalStore.Actions.SetSelectedLanguage(i18n.language));
        }
        deinitializeTranslation() {
            i18n.off('languageChanged', this.onLanguageChange);
        }
        getLanguageFromCookie() {
            const cookies = document.cookie.split(';');
            for (const cookie of cookies) {
                const [name, value] = cookie.trim().split('=');
                if (name === 'language') {
                    return value;
                }
            }
            return 'no';
        }
        setLanguageCookie(language) {
            const expires = new Date();
            expires.setFullYear(expires.getFullYear() + 10);
            document.cookie = `language=${language}; path=/; max-age=31536000`;
        }
    }
    Mixin._deps = [];
    __decorate([
        reduxBind(BoostPortalStore.path('selectedLanguage')),
        property({ type: String }),
        __metadata("design:type", String)
    ], Mixin.prototype, "currentLanguage", void 0);
    return Mixin;
}
